import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'
import type { ProfileListItem } from '../../types/api'
import Badge from '../../components/ui/Badge'

export default function HeadhunterCandidates() {
  const navigate = useNavigate()
  const [profiles, setProfiles] = useState<ProfileListItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.profiles.list()
      .then((res) => setProfiles(res.data))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <p className="text-text-muted text-sm">Loading candidates...</p>

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-heading tracking-tactical">CANDIDATE DATABASE</h1>
      <div className="border border-border-subtle">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border-subtle bg-surface-low">
              <th className="text-left px-4 py-3 text-xs text-text-muted tracking-tactical font-normal">CANDIDATE</th>
              <th className="text-left px-4 py-3 text-xs text-text-muted tracking-tactical font-normal hidden md:table-cell">SKILLS</th>
            </tr>
          </thead>
          <tbody>
            {profiles.map((p) => (
              <tr
                key={p.id}
                onClick={() => navigate(`/headhunter/candidates/${p.id}`)}
                className="border-b border-border-subtle hover:bg-surface-low transition-colors cursor-pointer"
              >
                <td className="px-4 py-3">
                  <p className="font-medium">{p.name}</p>
                </td>
                <td className="px-4 py-3 hidden md:table-cell">
                  <div className="flex flex-wrap gap-1">
                    {p.skills.slice(0, 5).map((s) => <Badge key={s} variant="muted">{s}</Badge>)}
                    {p.skills.length > 5 && <span className="text-xs text-text-muted">+{p.skills.length - 5}</span>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
